import { Box, Tab, Tabs, TextField, Typography, getContrastRatio } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import { useNavigate } from "react-router-dom";
import { generateLighterContrastColor } from "../../../utils/commonServices";
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
import {  getAllEventSongs, updateEventSongText } from "../actions";
import { getTeamEvents } from "../../teamsdashboard/actions";
import { getAllEvents } from "../../dashboard/actions";
import SongDropzone from "./SongDropzone";
import UploadedSongsTable from "./UploadedSongsTable";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CustomTooltip from "../../../components/CustomTooltip";
import CustomButton from "../../../components/CustomButton";
import { LoadingButton } from "@mui/lab";
import usePermissions from "../../../hooks/usePermissions";
import { PERMISSION, uploadCategory } from "../../../constants/constants";

const UploadSongPopup = (props) => {
  const {uploadProps} = props;
  const {
    selectedFiles, setSelectedFiles,
    uploadsInProgress, setUploadsInProgress,
    uploadStatus, setUploadStatus,
    progress, setProgress, uploadFiles,
    requestController, setRequestController,
    actionAfterSuccessfulUpload
  } = uploadProps;

      const dispatch = useDispatch()
      const navigate = useNavigate()
      const commonReducer = useSelector((state) => state.root.commonReducer);
      const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
      const projectReducer = useSelector((state) => state.projectReducer);
      const teamsReducer = useSelector((state) => state.root.teamsReducer);
      const [uploadedSongs , setUploadedSongs] = useState (projectReducer?.uploaded_songs)
      const [hasPermission] = usePermissions()

      const [theme] = useCustomTheme()
      const [activeTab, setActiveTab] = useState(projectReducer?.audio_popup_tab === 'notes' ? 'notes' : 'upload')
      const [editMode, setEditMode] = useState(false)
      const [songType, setSongType] = useState(commonReducer?.event_details?.song_type)
      const [disableUpload, setDisableUpload] = useState(false)


      const handleClose = () => {
        // if(isLoading === true){
        //   stopList( ()=> dispatch(updateProjectState({upload_song_popup : false}))  )
        // }else{
          dispatch(updateProjectState({upload_song_popup : false}))
       // }

      };

      const handleFocus = (event) => {
        const length = event.target.value?.trim()?.length;
        event.target.setSelectionRange(length, length);
      };

      const handleTabChange = (event, newValue) => {
        setActiveTab(newValue)
      };


    const saveSongText =()=>{
      const payload = {
        id: commonReducer?.production_event_id,
        song_type: songType
      }
      updateEventSongText(payload, dispatch, saveSongTextCallback)
    }

    const saveSongTextCallback = ()=>{
      !!teamsReducer.selected_team ?  getTeamEvents({  team_id: teamsReducer?.selected_team?.id}, dispatch) :    getAllEvents(dispatch);
      convertToViewMode()
    }

    useEffect(()=> {
      getAllEventSongs({event_id: commonReducer?.production_event_id}, dispatch)
    }, [])

    useEffect(() => {
       setUploadedSongs(projectReducer?.uploaded_songs)

    }, [ projectReducer?.uploaded_songs])

    const afterUploadCallback =()=>{

     // getAllEventSongs({event_id: commonReducer?.production_event_id}, dispatch, getEventSongsCallback)
    }

    // const getEventSongsCallback =()=>{
    //   setIsDisabled(false)
    // }



    const convertToViewMode = ()=>{
      setEditMode(false)
    }

    const convertToEditMode = ()=>{
      setEditMode(true)
    }



    useEffect(() => {
      const handleKeyDown = (e) => {
        e.stopPropagation();
        if (e.key === ' ' || e.key === 'f' || e.key ===  'arrowright' || e.key === 'k'  || e.key === 'm'  || e.key === 'arrowleft') {
          // e.preventDefault();
        }
      };

      if (projectReducer.upload_song_popup) {
        document.addEventListener('keydown', handleKeyDown, true);
      }

      return () => {
        document.removeEventListener('keydown', handleKeyDown, true);
      };
    }, [projectReducer.upload_song_popup]);

    // if (!projectReducer.upload_song_popup) return null;

  return (
    <CustomAlert
      open={projectReducer.upload_song_popup}
      handleClose={handleClose}
      height={{xs:'610px',md:'610px',lg:'630px' ,xl:'850px'}}
      // height={{xs:'550px',md:'610px',lg:'605px' ,xl:'700px'}}
      width={{xs:'600px',md:'740px',lg:'780px',xl:'1170px'}}
      >
        <Box sx={{display:'flex', flexDirection:'column', height:'100%', }} px={4} pt={1} pb={2}>
          <Box flexGrow={1} pt={{xs:3,sm:1, md:1.5, lg:2.5, xl:3}} sx={{display:'flex', flexDirection:'column', minHeight:0}} >

              <Box className='flex col' gap={{xs:0.5, lg:1}}  sx={{ flexShrink:0 }}>
                <Box className='flex j-between a-center' style={{width:{xs:'90%', md:'80%'}}}>
                  <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'14px',sm:'14px',md:'16px',lg:'20px',xl:'30px'}}}>My Audio</Typography>
                </Box>

                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  sx={{
                    minHeight:{xs:'28px',md:'32px',lg:'36px',xl:'48px'},
                    mb:{xs:0.5, lg:1},
                    '& .MuiTab-root': {
                      fontFamily:'Rubik',
                      fontWeight:600,
                      textTransform:'none',
                      minHeight:{xs:'28px',md:'32px',lg:'36px',xl:'48px'},
                      fontSize:{xs:'10px',md:'11px',lg:'13px',xl:'18px'},
                      padding:{xs:'4px 10px', xl:'8px 16px'},
                    },
                    '& .Mui-selected': {
                      color:'#08231B !important',
                    },
                    '& .MuiTabs-indicator': {
                      backgroundColor: theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main),
                    },
                  }}
                >
                  <Tab label="Upload Audio" value="upload" />
                  <Tab label="Music Notes" value="notes" />
                </Tabs>
              </Box>

                {activeTab === 'upload' && <Box sx={{flex:1, minHeight:0, display:'flex', flexDirection:'column'}}>
              {   ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) ) &&    <Box  sx={{flexShrink:0, height:'100px', width: '90%' , minWidth: '320px', marginTop:{xs: '20px', md: '10px'}, marginBottom:{xs:'10px', sm:'15px',md:'5px',lg:'25px', xl:'70px'}, ml:1}}>
                    <SongDropzone
                    flex='row'
                    //  isDisabled={
                    //      isLoading
                    //    }
                     files={selectedFiles}
                     setFiles={setSelectedFiles}
                     setUploadStatus={setUploadStatus}
                     uploadedFiles = {uploadedSongs}
                     setProgress={setProgress}
                     setRequestController={setRequestController}
                     category = {uploadCategory.songs}
                     onFileSelection = {handleClose}
                     extraPayload = {{event_id: commonReducer?.production_event_id}}
                    //  height={{xs: '80px',sm:'75px',md:'85px',lg:'105px', xl:'140px'}}
                     height={{xs: '90px',sm:'85px',md:'85px',lg:'115px', xl:'150px'}}
                     accept = {{
                      'audio/mpeg': ['.mp3', '.MP3'],
                      'audio/wav': ['.wav', '.WAV'],
                      'audio/ogg': ['.ogg', '.OGG'],
                      'audio/flac': ['.flac', '.FLAC'],
                      'audio/aiff': ['.aiff', '.AIFF'],
                      'audio/x-aiff': ['.aif', '.AIF'],
                      'audio/x-caf': ['.caf', '.CAF'],
                      'audio/mp4': ['.mp4', '.MP4', '.m4a', '.M4A'],
                      'audio/aac': ['.aac', '.AAC']
                    }}
                     setEnableFileUpload

                   />
                   <Box className='flex row j-end ' gap={0.5} sx={{alignItems: 'flex-end'}} >
                    <Typography textAlign={"end"} sx={{fontSize: {xs:'9px',md:'10px',lg:'11px',xl:'15px'}, fontWeight:600, mt:'3px'}}>Audio files upto 500 mb.</Typography>
                    <CustomTooltip title=" Files Allowed: .wav, .ogg, .flac, .mp3, .mp4, .m4a, .aiff, .caf, .aac " >
                      <InfoOutlinedIcon sx={{fontSize:  {xs:'9px !important',md:'9px !important',lg:'10.67px !important', xl:'16px !important'}, color: '#000000',  marginBottom: '2px'}} />
                    </CustomTooltip>
                   </Box>

                    </Box>}


                    <Box sx={{flex:1, minHeight:0}}  className= 'flex row j-between a-start' >

                      <Box pl={1} component='div'  sx={{  maxHeight: {xs: '130px', sm: '120px', md: '210px', lg: '150px', xl: '215px'} ,  maxWidth:'85%', width:'85%'}}>

                        <UploadedSongsTable
                          // progress= {progress}
                          // stopUpload = {stopUpload}
                          // uploadStatus = {uploadStatus}
                          // files = {files}
                          uploadedSongs={uploadedSongs}
                          // stopList={stopList}
                          // isUploading={isLoading}
                          height={{xs: '100px',sm:'85px',md:'100px',lg:'140px', xl:'180px'}}

                          // setUploadedSongs={setUploadedSongs}
                        />

                      </Box>
                </Box>
                </Box>}

                {activeTab === 'notes' && <Box className='flex col' sx={{flex:1, minHeight:0 }}>
                  <Box className='flex j-end a-center' mb={1} gap={2} sx={{flexShrink:0}}>
                    {(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) &&
                      <CustomButton
                        btnText={'Cancel'}
                        onClick={convertToViewMode}
                        type='button'
                        color='secondary'
                        variant='outlined'
                        disabled={ commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null}
                        style={{
                          borderRadius: '5px',
                          border: "none",
                          textTransform:'none',
                        }}
                        sx={{fontSize:{xs:'9px',sm:'10px',lg:'12px',xl:'18px'},  fontWeight:600, height:{xs:'22px',sm:'24px',lg:'28px',xl:"40px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
                      />
                    }
                    {( hasPermission(PERMISSION.PROJECT.INFO.EDIT) &&   ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) ) ) &&  <LoadingButton
                      onClick={(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) ? saveSongText : convertToEditMode}
                      type='button'
                      color='secondary'
                      variant='contained'
                      loading={projectReducer?.is_loading}
                      loadingPosition="end"
                      style={{
                        borderRadius: '5px',
                        border: "none",
                        textTransform:'none',
                      }}
                      endIcon={(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) ? <SaveOutlinedIcon style={{fontSize:'15px'}} /> : <EditOutlinedIcon style={{fontSize:'15px'}} />}
                      sx={{fontSize:{xs:'9px',sm:'10px',lg:'12px',xl:'18px'},  fontWeight:600, height:{xs:'22px',sm:'24px',lg:'28px',xl:"40px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
                    >{(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) ? 'Save' : 'Edit'}</LoadingButton>
                    }
                  </Box>

                  <Box className='flex' sx={{ flex:1, overflowY:'auto', minHeight:0 }} >
                    {(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) ?   <TextField
                        sx={{mt:0.5, width:'100%', '& .MuiInputBase-root': {alignItems:'flex-start'}}}
                        id="outlined-multiline-static"
                        autoFocus
                        fullWidth
                        multiline
                        minRows={9}
                        maxRows={16}
                        inputProps={{
                          maxLength: 60000
                        }}
                        placeholder="Enter mood, genre..."
                        onFocus={handleFocus}
                        defaultValue={commonReducer?.event_details?.song_type}
                    onChange={(event) => setSongType(  songType != ""
                      ? event.target.value
                      : event.target.value.trim())}
                    value={songType}

                         /> : (
                            <Typography style={{ whiteSpace: "pre-line", wordBreak:'break-all' }}   sx={{mt:0.5}}>{commonReducer?.event_details?.song_type}</Typography>
                         )}
                  </Box>
                </Box>}

              <Box className='flex j-end a-end' mt={1} sx={{flexShrink:0}}>
                 <CheckIcon
                    onClick={activeTab === 'upload' ? handleClose : (!(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) ? handleClose : null)}
                    color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}
                    sx={{
                      fontSize:{xs:'28px',sm:'30px',md:'42px', lg:'56px',xl:'75px'},
                      cursor: activeTab === 'upload' ? 'pointer' : (!(editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) && 'pointer'),
                      opacity: activeTab === 'upload' ? 0.5 : ((editMode || commonReducer?.event_details?.song_type == '' || commonReducer?.event_details?.song_type == null ) ? 0.6 : 1),
                    }}
                 />
              </Box>
          </Box>
      </Box>

    </CustomAlert>

  )
}

export default UploadSongPopup
